import React from "react";
import axios from "axios";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import Form from "react-bootstrap/Form";
// import Container from "react-bootstrap/Container";
// import Navbar from "react-bootstrap/Navbar";
// import { useState } from "react";
// import { useNavigate } from "react-router-dom";

const LoginComp = () => {
    // const [userState, setUserSate] = useState();
    const makeRequest = () => {
        const email__ = document.getElementById("Email").value;
        const password__ = document.getElementById("Password1").value;
        axios
            .post(
                "http://tagard.in:8005/usr/login",

                {
                    email: email__,
                    password: password__,
                }
            )
            .then((response) => {
                // if (response.status === 200) {
                // If the response status is 200, set status to true
                // setUserSate(true);
                // } else {
                // setUserSate(false);
                // }
                console.log(response.status);
            })
            .catch((error) => {
                console.error(error);
            });
    };
    return (
        <>
            <Form className="w-50 ms-4 mt-5">
                <Form.Group className="mb-3">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                        type="email"
                        placeholder="Enter email"
                        className="mb-3"
                        id="Email"
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                        type="password"
                        placeholder="Password1"
                        className="mb-3"
                        id="Password1"
                    />
                </Form.Group>
                <Button
                    variant="primary"
                    type="button"
                    onClick={() => makeRequest()}
                >
                    Submit
                </Button>
            </Form>
        </>
    );
};

function Login() {
    return (
        <div className="login">
            <form>
                <h3 className="mt-50">Sing In</h3>
                <div>
                    <LoginComp />
                </div>
            </form>
        </div>
    );
}

export default Login;
